import { Component, OnInit, Input } from '@angular/core';
import { ModalController, AlertController, NavController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { UtilService } from '../../service/util.service';
import { environment } from '../../../environments/environment';
import { PosService } from '../../pages/pos/pos.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-member-point',
  templateUrl: './member-point.component.html',
  styleUrls: ['./member-point.component.scss'],
})
export class MemberPointComponent implements OnInit {

  @Input() token: any;
  @Input() totalTransaction: any;
  @Input() name: any;
  memberParam: any;
  baseUrl: any;
  addPointForm: boolean = false;
  usedPointForm: boolean = false;
  addMemberForm :boolean = false;
  searchMemberForm:boolean=true;
  setPointVal: boolean = false;
  btnFindMember: boolean = false;
  memberId: any ='';
  memberIdentityNumber: any;
  memberName: any;
  memberPhone: any ='';
  memberPoint: any = 0;
  memberPointUsed: any;
  memberPointforUseList: any[] = [];
  email:any='';
  birth_place:any='';
  birth_date:any='';
  gender:any='';
  profession:any='';
  address:any='';
  identityNumber:any ='';
  db: any;
  selectedFormType= '2';
  countryData:any[]=[];
  cityData:any[]=[];
  districtData:any[]=[];
  subdistrictData:any[]=[];
  provinceData:any[]=[];
  countryId:any=0;
  provinceId:any=0;
  cityId:any=0;
  districtId:any=0;
  subdistrictId:any=0;
  
  selectedProvince:any[]=[];
  selectedCity:any[]=[];
  selectedDistrict:any[]=[];
  selectedSubdistrict:any[]=[];
  
  countryName:any = '';
  provinceName:any ='';
  cityName:any ='';
  districtName:any = '';
  subdistrictName:any ='';

  constructor(
    public modalController: ModalController,
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private alertController: AlertController,
    private posService: PosService,
    private http: HttpClient,
    private navCtrl :NavController
  ) {
    this.baseUrl = environment.apiUrl;
  }

  ngOnInit() {
    this.getCountry();
  }

  async dismissModal() {
    let close: string = '';
    let pointMutationType: any;

    if(this.usedPointForm === true) {
      if(this.memberPointUsed !== undefined) {
        if(this.setPointVal === true) {
          let value = parseInt(this.memberPointUsed) * 100;
          pointMutationType = 'O';
          close = this.memberId + '#' + this.memberPhone + '#' + this.memberPointUsed + '#' + value + '#' + pointMutationType;
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Silahkan klik tombol "Pakai Point" terlebih dahulu!' }).then(t => t.present());
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Anda belum memilih jumlah point!' }).then(t => t.present());
      }
    }
    else if(this.addPointForm === true) {
      if(this.memberId !== undefined && this.memberId !== '') {
        pointMutationType = 'I';
        close = this.memberId + '#' + this.memberPhone + '#' + 0 + '#' + 0 + '#' + pointMutationType;
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Anda belum memilih member!' }).then(t => t.present());
      }
    }
    else if( this.searchMemberForm==true){ 
      close = this.memberId + '#' + this.memberPhone + '#' + 0 + '#' + 0 + '#' + "AM";
    }
    else if(this.addMemberForm == true){ 
      close = this.memberId + '#' + this.memberPhone + '#' + 0 + '#' + 0 + '#' + "AM";
    }
    else {
      //
    }

    await this.modalController.dismiss(close);
  }

  radioGroupChange(event: any) {
    this.btnFindMember = false;
    let radioId = event.detail.value;
    this.addMemberForm =false;
    this.searchMemberForm = false;
    if(radioId === '0') {
      this.usedPointForm = true;
      this.addPointForm = false;
    }
    else if(radioId === '1') {
      this.usedPointForm = false;
      this.addPointForm = true;
    }
    else if(radioId === '2') {
      this.usedPointForm = false;
      this.addPointForm = false;
      this.searchMemberForm = true;
      this.searchMember();
    }
    else if(radioId === '3') {
      this.usedPointForm = false;
      this.addPointForm = false;
      this.addMember();
      this.btnFindMember = true;
    }
    else {
      console.log('Error');
    }

    this.clearField();
  }

  searchMember() {
    if(this.memberParam !== undefined && this.memberParam !== '') {
      this.utilService.loadingPresent('Harap tunggu...')
      .then(() => {
        
      let options = {
        "token": this.token,
        "phoneNumber": this.memberParam
      };
        this.posService.getMemberByPhone(options).subscribe(async (response) => {
          if(response.results) {
            console.log(response.results);
            if(response.results.length > 0) {
              this.utilService.loadingDismiss();
              this.memberId = response.results[0].id;
              this.memberIdentityNumber =response.results[0].identity_number;
              this.memberName = response.results[0].customer_name;
              this.memberPhone = response.results[0].phone;
              this.memberPoint = response.results[0].point_remains;
              this.birth_place = response.results[0].birth_place;
              this.birth_date = response.results[0].birth_date;
              this.gender = response.results[0].gender;
              this.profession = response.results[0].profession;
              this.address = response.results[0].address;
              this.email = response.results[0].email;
              let findCountry = this.countryData.find(x=>x.id==response.results[0].country_id);
              if(findCountry){
                this.countryName = findCountry.country_name;
              }
              let findProvince= this.provinceData.find(x=>x.id==response.results[0].province_id);
              if(findProvince){
                this.provinceName = findProvince.province_name;
              }
              let findCity= this.cityData.find(x=>x.id==response.results[0].city_id);
              if(findCity){
                this.cityName =findCity.city_name;
              }
              let findDistrict= this.districtData.find(x=>x.id==response.results[0].district_id);
              if(findDistrict){
              this.districtName = findDistrict.district_name;
              }
              let findSubdistrict= this.subdistrictData.find(x=>x.id==response.results[0].subdistrict_id);
              if(findSubdistrict){
              this.subdistrictName = findSubdistrict.subdistrict_name;
              }
            }
            else {
              this.memberId = '';
              this.memberIdentityNumber = '';
              this.memberName = '';
              this.memberPhone = '';
              this.memberPoint = '';
              this.email = '';
              this.birth_place = '';
              this.birth_date = '';
              this.gender ='';
              this.profession = '';
              this.address = '';
              this.countryName = '';
              this.provinceName ='';
              this.cityName ='';
              this.districtName = '';
              this.subdistrictName ='';
              this.utilService.loadingDismiss();
              this.toastCtrl.create({ duration: 2000, message: 'Member tidak ditemukan!' }).then(t => t.present());
            }
           
            if(this.usedPointForm === true) {
              this.memberPointforUseList = [];
              if(this.totalTransaction !== 0) {
                let pointLimit: any = parseInt(this.totalTransaction) / 100;
                if(this.memberPoint !== 0) {
                  let point = 0;
                  let pointVal = 0;
                  let count: any = parseInt(this.memberPoint) / 100;
                  if(parseInt(count) !== 0) {
                    for(let x = 0; x <= parseInt(count); x++) {
                      if(point <= (parseInt(pointLimit) + 100)) {
                        let pointList = {
                          'point': point,
                          'point_value': pointVal
                        };
                        this.memberPointforUseList.push(pointList);
                        point = point + 100;
                        pointVal = pointVal + 10000;
                      }
                    }
                  } else {
                    let pointList = {
                      'point': 0,
                      'point_value': 0
                    }
  
                    this.memberPointforUseList.push(pointList);
                  }
                } else {
                  let pointList = {
                    'point': 0,
                    'point_value': 0
                  }

                  this.memberPointforUseList.push(pointList);
                }
              } else {
                let pointList = {
                  'point': 0,
                  'point_value': 0
                }

                this.memberPointforUseList.push(pointList);
              }
              this.memberParam = undefined;
            }
          } 
        }, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data! Silahkan refresh!' }).then(t => t.present());
        });
      });
    } else {
      this.toastCtrl.create({ duration: 2000, message: 'Silahkan isi kolom pencarian terlebih dahulu!' }).then(t => t.present());
    }
  }

  clearField() {
    this.memberId = '';
    this.memberIdentityNumber = '';
    this.memberName = '';
    this.memberPhone = '';
    this.memberPoint = 0;
    this.memberParam = undefined;
    this.memberPointUsed = undefined;
    this.setPointVal = false;
    this.birth_place='';
    this.birth_date='';
    this.gender='';
    this.profession='';
    this.address='';
    this.identityNumber ='';
    this.email ='';
    this.countryId=0;
    this.provinceId=0;
    this.cityId=0;
    this.districtId=0;
    this.subdistrictId=0;
  }

  setPointUsed() {
    if(this.memberPointUsed === undefined) {
      this.toastCtrl.create({ duration: 2000, message: 'Silahkan pilih jumlah point terlebih dahulu!' }).then(t => t.present());
    } else {
      if(this.setPointVal === false) {
        this.setPointVal = true;
        this.dismissModal();
      } else {
        this.setPointVal = false;
      }
    }
  }
  getCountry() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const paramsOpts = new HttpParams()
        .set('token', this.token)
      const reqOpts = new HttpHeaders()
        .set('Accept', 'application/json');
      this.http.get(this.baseUrl + 'customer/create', { headers: reqOpts, params: paramsOpts })
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.countryData =response.results.country;
          this.provinceData =response.results.province;
          this.cityData =response.results.city;
          this.districtData =response.results.district;
          this.subdistrictData =response.results.subdistrict;
        }else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }
  addMember() {
    this.clearField();
    this.addPointForm = false;
    this.usedPointForm = false;
    this.addMemberForm=true;
  }
  inputCustomer() {
      if(this.memberPhone!='' && this.memberName!=''){        
        this.utilService.loadingPresent('Harap tunggu...')
        .then(() => {
          const paramsOpts = new HttpParams()
            .set('token', this.token)
    
          const reqOpts = new HttpHeaders()
            .set('Accept', 'application/json'),
          formData = new FormData();
          formData.append('customer_name', this.memberName);
          formData.append('identity_number', this.identityNumber);
          formData.append('phone', this.memberPhone);
          formData.append('email', this.email);
          formData.append('created_by', this.name);
          formData.append('customer_type_id', '1');
          formData.append('birth_place', this.birth_place);
          formData.append('birth_date', this.birth_date);
          formData.append('gender', this.gender);
          formData.append('profession', this.profession);
          formData.append('address', this.address);
          formData.append('province_id',this.provinceId);
          formData.append('country_id',this.countryId);
          formData.append('city_id',this.cityId);
          formData.append('district_id',this.districtId);
          formData.append('subdistrict_id',this.subdistrictId);
          this.http.post(this.baseUrl + 'customer', formData, { headers: reqOpts, params: paramsOpts })
          .subscribe((response: any) => {
            this.utilService.loadingDismiss();
            if(response.status.code === 201) {
              this.memberId = response.results.data.id;
              this.memberIdentityNumber =response.results.data.identity_number;
              this.memberName = response.results.data.customer_name;
              this.memberPhone = response.results.data.phone;
              this.inputMemberPointData(this.memberId);
            }
            else if(response.status.code === 202) {
              this.toastCtrl.create({ duration: 2000, message:response.message }).then(t => t.present());
            } else {
              this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
            }
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          })
        });
      }
      else{
        let emptyMsg='';
        if(this.memberPhone==''){
          emptyMsg +='Phone Number tidak boleh kosong';
        }
        if(this.memberName==''){
          emptyMsg +='<br>Customer Name tidak boleh kosong';
        }
        this.toastCtrl.create({ duration: 2000, message: emptyMsg }).then(t => t.present());
      }
    }
  
  inputMemberPointData(id: any) {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const paramsOpts = new HttpParams()
        .set('token', this.token)

      const reqOpts = new HttpHeaders()
        .set('Accept', 'application/json'),
      formData = new FormData();
      formData.append('customer_id', id);
      formData.append('created_by', this.name);

      this.http.post(this.baseUrl + 'member-point', formData, { headers: reqOpts, params: paramsOpts })
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showConfirmInput();
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }
    
  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.dismissModal();
          }
        }
      ]
    });

    await alert.present();
  }
  selectCountry(event){
    this.countryId = event.value.id;
    this.provinceId ='';
    this.cityId ='';
    this.districtId ='';
    this.subdistrictId ='';
    this.filterProvinceByCountry();
  }
  filterProvinceByCountry(){
    this.selectedCity=[];
    this.selectedDistrict=[];
    this.selectedSubdistrict=[];
    this.selectedProvince = this.provinceData.filter(x=>x.country_id==this.countryId);
  }
  selectProvince(event){
    this.provinceId = event.value.id;
    this.cityId ='';
    this.districtId ='';
    this.subdistrictId ='';
    this.filterCityByProvince();
  }
  filterCityByProvince(){
    this.selectedDistrict=[];
    this.selectedSubdistrict=[];
    this.selectedCity = this.cityData.filter(x=>x.province_id==this.provinceId);
  }
  selectCity(event){
    this.cityId = event.value.id;
    this.districtId ='';
    this.subdistrictId ='';
    this.filterDistrictByCity();
  }
  filterDistrictByCity(){
    this.selectedSubdistrict=[];
    this.selectedDistrict = this.districtData.filter(x=>x.city_id==this.cityId);
  }
  selectDistrict(event){
    this.districtId = event.value.id;
    this.subdistrictId ='';
    this.filterSubdistrictByDistrict();
  }
  filterSubdistrictByDistrict(){
    this.selectedSubdistrict = this.subdistrictData.filter(x=>x.district_id==this.districtId);
  }
  selectSubdistrict(event){
    this.subdistrictId = event.value.id;
  }

  numberOnlyValidation(event: any) {
    const pattern = /[0-9.,]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }
}
